import { useTranslation } from "@opendash/i18n";
import { stringToTag } from "@opendash/ui";
import { Flex, Tag } from "antd";
import dayjs from "dayjs";
import { observer } from "mobx-react-lite";
import React from "react";
import { useRelativeTime } from "../../../_shared/time/hooks/useRelativeTime";
import {
  Message,
  Schedule_Execution,
  Ticket,
} from "../../../js/parsegenerated";
import { getMessageType } from "../helpers/helpers";

type Props = {
  message: Message;
};

export const MessageTitle = observer((props: Props) => {
  const t = useTranslation();
  const getRelativeTime = useRelativeTime();
  const tag = getEntryTag();
  const date = dayjs(
    props.message.get("displayAt") ?? props.message.get("createdAt")
  );

  function getEntryTag() {
    const type = getMessageType(props.message);
    if (type === "message") {
      return t("maintenance:schema." + Message.className);
    }
    if (type === "ticket") {
      return t("maintenance:schema." + Ticket.className);
    }
    if (type === "schedule") {
      return t("maintenance:schema." + Schedule_Execution.className);
    }
  }

  function getTitleColor() {
    const type = getMessageType(props.message);
    if (type === "message") return "#1890ff";
    if (type === "ticket") return "#faad14";
    if (type === "schedule") return "#52c41a";
  }

  return (
    <Flex justify="space-between" gap="small">
      <span>
        <Tag color={getTitleColor()}>{tag}</Tag>
        {stringToTag(
          t(props.message.get("title"), props.message.get("data")?.translation),
          "'"
        )}
      </span>
      <span>{getRelativeTime(date)}</span>
    </Flex>
  );
});
